import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { FinancialEntityBranch } from '@models/swagger';
import { FinancialEntityBranchesParams } from './service';

export enum FinancialEntityBranchesActions {
  Failure = '[Application Utilities FinancialEntityBranches] Failure',
  Request = '[Application Utilities FinancialEntityBranches] Request',
  Success = '[Application Utilities FinancialEntityBranches] Success',
  Reset = '[Application Utilities FinancialEntityBranches] Reset',
}

export const FinancialEntityBranchesFailure = createAction(
  FinancialEntityBranchesActions.Failure,
  props<{ error: HttpErrorResponse }>()
);

export const FinancialEntityBranchesRequest = createAction(
  FinancialEntityBranchesActions.Request,
  props<{ parameters: FinancialEntityBranchesParams }>()
);

export const FinancialEntityBranchesSuccess = createAction(
  FinancialEntityBranchesActions.Success,
  props<{ data: FinancialEntityBranch[] }>()
);

export const FinancialEntityBranchesReset = createAction(FinancialEntityBranchesActions.Reset);
